module.exports = __webpack_public_path__ + "static/media/gautam.b0ba72df.jpeg";